export default __webpack_public_path__ + "static/media/selectcell.e8449e81.mp3";